import { GridRowModel } from "@mui/x-data-grid";
import { useCallback } from "react";
import { useInfo } from "../useInfo";
import { RowMutations } from "./UseRowEdit";

const initialRowMutationState: RowMutations = {
  updatedValue: '',
  editedKey: '',
  updatedLabel: '',
  originalLabel: ''
};

export const UseRowEditCalculator = () => {
    const { employmentTypeDisplayName } = useInfo();

    return useCallback(
      (updatedRow: GridRowModel, originalRow: GridRowModel) => {
        for (const key in updatedRow) {
          // linter dislikes hasOwnProperty usage and es2022 hasOwn is unavailable in the current environment,
          // so 'key in updatedRow' may work for now.
          if (key in updatedRow) {
            // I couldn't think of a better way to do this. What we show a user isn't the data that we need to update the db for the matching data, so we have to do some kind of mapping. Have any better ideas?
            // the labels in the mutations are what display in the confirmation dialog.
            if (updatedRow[key] !== originalRow[key]) {
              const mutation: RowMutations = { ...initialRowMutationState };
  
              switch (key) {
                case 'employment_type':
                    mutation.updatedLabel = employmentTypeDisplayName(updatedRow[key]) ?? '';
                    mutation.originalLabel = employmentTypeDisplayName(originalRow[key]) ?? '';
                    mutation.updatedValue = updatedRow[key];
                    mutation.editedKey = 'employment_type';
                    break;
                case 'role_name':
                    // The row stores the role as a nested object (role.name), so the
                    // 'role_name' field only exists on the edited row. Read the previous
                    // value from originalRow.role.name to get the correct original label.
                    mutation.updatedValue = updatedRow[key];
                    mutation.updatedLabel = updatedRow[key];
                    mutation.originalLabel = originalRow.role?.name ?? '';
                    mutation.editedKey = key;
                    break;
                default:
                  mutation.updatedValue = updatedRow[key];
                  mutation.updatedLabel = updatedRow[key];
                  mutation.originalLabel = originalRow[key];
                  mutation.editedKey = key;
              }
              
              return mutation
            }
          }
        }
  
        return null;
      },
      [employmentTypeDisplayName]
    );
}